import React from 'react'
import './Spinner.css'

const Spinner = ()=>{

    return (
        <div>
            <span className="loader"></span>
      </div>
    )
}

export default Spinner